import React from "react";

const LeftArrow = ({ className }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <rect
        x="0.6"
        y="0.6"
        width="46.8"
        height="46.8"
        rx="23.4"
        stroke="white"
        strokeWidth="1.2"
      />
      <path
        d="M28 17L20 24L28 31"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LeftArrow;
